import { Layout } from '../../components/Layout/Layout';
import './ProductPagePanes.css';
import { RawHtml } from '../../components/RawHtml';
import { ApiFeatureSheet, ApiProductPage } from '../../types';
import { ProductInformation } from './ProductInformation';
import { FeatureSheetCard } from './FeatureSheetCard';
import { EmbeddedYoutubeVideo } from '../EmbeddedYoutubeVideo/EmbeddedYoutubeVideo';
import { extractDescriptionVideos } from './descriptionVideos';

// a description is not a playlist: a handful of players is plenty, and each one is an iframe
const MAX_EMBEDS = 10;

export const ProductPageBottomPane = ({
	productPageData,
	featureSheet,
}: {
	productPageData: ApiProductPage;
	featureSheet: ApiFeatureSheet;
}) => {
	const { html, videos } = extractDescriptionVideos(productPageData.description ?? '', MAX_EMBEDS);

	return (
		<div className="product-info-bottom-pane">
			<Layout type="two-pane">
				<div className="left-pane product-description">
					<RawHtml html={html} />
					{videos.map((video) => (
						<EmbeddedYoutubeVideo
							key={`${video.id}|${video.start ?? 0}|${video.nocookie ? 1 : 0}`}
							videoId={video.id}
							start={video.start}
							nocookie={video.nocookie}
						/>
					))}
				</div>
				<div className="right-pane">
					<ProductInformation productData={productPageData} />
					{featureSheet && featureSheet.featureGroups && featureSheet.featureGroups.length > 0 ? (
						<FeatureSheetCard data={featureSheet} />
					) : null}
				</div>
			</Layout>
		</div>
	);
};
